import React, { Component } from 'react'

import '../styles/scss/chartist/chartist.scss'

class PieChart extends Component {
  render() {
    return (
      <div className="pie-chart" style={{height: '450px'}}></div>
    )
  }
}

export default PieChart
